import '../CsvJsonInfoPages.scss';


function TechnicalData() {

    const data = [
        { field: 1, description: 'CAP Vehicle Identification Number' },
        { field: 2, description: 'Technical Data Date (dd/mm/yyyy)' },
        { field: 3, description: 'Insurance Group 1' },
        { field: 4, description: 'Insurance Group 2' },
        { field: 5, description: 'Kerb Weight (kg) (Dry Weight for BIKES)' },
        { field: 6, description: 'Length (mm)' },
        { field: 7, description: 'Width (mm)' },
        { field: 8, description: 'Engine No.' },
        { field: 9, description: 'Vin/Frame No./Chassis No.' },
        { field: 10, description: "Set to 1 if the following 3 MPG's are EC MPG's." },
        { field: 11, description: 'MPG - Urban (###.##)' },
        { field: 12, description: 'MPG - Extra Urban (###.##)' },
        { field: 13, description: 'MPG - Combined (###.##)' },
        { field: 14, description: '0 to 62 (###.##)' },
        { field: 15, description: 'Topspeed (####)' },
        { field: 16, description: 'Gross Vehicle Weight (kg) (######)' },
        { field: 17, description: 'Wheelbase (mm) (######)' },
        { field: 18, description: 'Bore (mm) (###.##)' },
        { field: 19, description: 'Stroke (mm) (###.##)' },
        { field: 20, description: 'Set to 1 if Special Edition' },
        { field: 21, description: 'Set to 1 if Special Order' },
        { field: 22, description: 'CC (######)' },
        { field: 23, description: 'BHP (#####.##)' },
        { field: 24, description: 'Set to 1 if Introduced on Technical Data Date' },
        { field: 25, description: 'Set to 1 if Discontinued on Technical Data Date' },
        { field: 26, description: 'Set to 1 if Re-Introduced on Technical Data Date' },
        { field: 27, description: 'Set to 1 if BHP value is PS.' },
        { field: 28, description: 'Set to 1 if 0 to 62 value is 0 to 60' },
        { field: 29, description: 'Fuel Tank Capacity (ltr) (###.##)' },
        { field: 30, description: 'Front Tyre Size' },
        { field: 31, description: 'Manufacturers Standard Warranty Years' },
        { field: 32, description: 'Manufacturers Standard Warranty Mileage' },
        { field: 33, description: 'Manufacturers Paint Guarantee in Years' },
        { field: 34, description: 'Corrosion Perforation Guarantee in Years' },
        { field: 35, description: 'Towing Weight Braked (kg) (####.##)' },
        { field: 36, description: 'Towing Weight UnBraked (kg) (####.##)' },
        { field: 37, description: 'Maximum Load Weight/Payload (kg) (#####.##)' },
        { field: 38, description: 'Width Including Mirrors (mm) (#####.##)' },
        { field: 39, description: 'Height (mm) (#####.##)' },
        { field: 40, description: 'Height Including Roof Rails (mm) (#####.##)' },
        { field: 41, description: 'Load Length (mm) (######.##)' },
        { field: 42, description: 'Load Width (mm) (######.##)' },
        { field: 43, description: 'Load Height (mm) (######.##)' },
        { field: 44, description: 'Load Volume Commercials (cu.m) (######.##)' },
        { field: 45, description: 'Boot Capacity (ltr) (######.##)' },
        { field: 46, description: 'Load Vol 2nd Row Seats Up (cu.m) (######.##)' },
        { field: 47, description: 'Load Vol 2nd Row Seats Down (cu.m) (######.##)' },
        { field: 48, description: 'Load Vol 3rd Row Seats Up (cu.m) (######.##)' },
        { field: 49, description: 'Load Vol 3rd Row Seats Down (cu.m) (######.##)' },
        { field: 50, description: 'Load Vol 2nd Row Seats Removed (cu.m)(######.##)' },
        { field: 51, description: 'Load Vol 3rd Row Seats Removed (cu.m) (######.##)' },
        { field: 52, description: 'No. Of Seats (##)' },
        { field: 53, description: 'Engine Power KW (#####.##)' },
        { field: 54, description: 'Engine Power RPM (#####.##)' },
        { field: 55, description: 'Engine Torque LBS FT (#####.##)' },
        { field: 56, description: 'Engine Torque NM (#####.##)' },
        { field: 57, description: 'Engine Torque RPM' },
        { field: 58, description: 'Tyre Size Rear' },
        { field: 59, description: 'Tyre Size Spare' },
        { field: 60, description: 'Wheel Type' },
        { field: 61, description: 'Cylinders (##)' },
        { field: 62, description: 'Cylinder Layout' },
        { field: 63, description: 'No. Of Valves (##)' },
        { field: 64, description: 'Camshaft' },
        { field: 65, description: 'Fuel Delivery' },
        { field: 66, description: 'Set to 1 if Catalytic Converter' },
        { field: 67, description: 'Engine Layout' },
        { field: 68, description: 'Compression Ratio' },
        { field: 69, description: 'Transmission' },
        { field: 70, description: 'Drive' },
        { field: 71, description: 'Gears' },
        { field: 72, description: 'CO2 (g/km)' },
        { field: 73, description: 'Standard Emissions' },
        { field: 74, description: 'Wheel Style' },
        { field: 75, description: 'Maximum Roof Load (kg) (#####.##)' },
        { field: 76, description: 'Luggage Capacity (ltr) (#####.##)' },
        { field: 77, description: 'Turning Circle (Kerb to Kerb) (m) (####.##)' },
        { field: 78, description: 'Set to 1 if Auto Transmission' },
        { field: 79, description: 'Set to 1 if Manual Transmission' },
        { field: 80, description: 'Plated Front Axle (kg) (######)' },
        { field: 81, description: 'Plated 2nd Axle (kg) (######)' },
        { field: 82, description: 'Plated 3rd Axle (kg) (######)' },
        { field: 83, description: 'Plated 4th Axle (kg) (######)' },
        { field: 84, description: 'Gross Train Weight (kg) (######)' },
        { field: 85, description: 'Front Overhang (mm) (######)' },
        { field: 86, description: 'Rear Overhang (mm) (######)' },
        { field: 87, description: 'Side Load Door Width (mm) (######)' },
        { field: 88, description: 'Side Load Door Height (mm) (######)' },
        { field: 89, description: 'Lower Rear Door Width (mm) (######)' },
        { field: 90, description: 'Upper Rear Door Width (mm) (######)' },
        { field: 91, description: 'Rear Door Height (mm) (######)' },
        { field: 92, description: 'Load Deck Height (mm) (######)' },
        { field: 93, description: 'Load Space Wid Btwn Wheel Arches (mm)(######)' },
        { field: 94, description: 'Turning Circle (Wall to Wall) (m) (####.##)' },
        { field: 95, description: 'Engine Torque MKG (#####.##)' },
        { field: 96, description: 'Pedestrian Test (Set to 0,1,2,3 or 4 stars or 9 for No Data)' },
        { field: 97, description: 'EURO NCAP (Set to 0,1,2,3,4 or 5 stars or 9 for No Data)' },
        { field: 98, description: '1 if an aspect of safety gave cause for concern.' },
        { field: 99, description: 'EC Standard' },
        { field: 100, description: 'Noise Level dB(A) (###.##)' },
        { field: 101, description: 'CO (g/km) (##.###)' },
        { field: 102, description: 'HC (g/km) (##.###)' },
        { field: 103, description: 'NOx (g/km) (##.###)' },
        { field: 104, description: 'HC+NOx (g/km) (##.###)' },
        { field: 105, description: 'Emissions Particles (g/km) (##.###)' },
        { field: 106, description: 'CAP Code' },
        { field: 107, description: 'Insurance Group - Number between 1 and 50' },
        { field: 108, description: 'Insurance Group Suffix' },
        { field: 109, description: 'Set to 1 if this vehicle is classed as a car for VED purposes' },
        { field: 110, description: 'Service Interval Mileage (######)' },
        { field: 111, description: 'Service Interval Frequency – Months (##)' },
        { field: 112, description: 'Timing Belt Interval Mileage (######)' },
        { field: 113, description: 'Timing Belt Interval Frequency – Months (###)' },
        { field: 114, description: 'NCAP Adult Occupancy Protection % (###)' },
        { field: 115, description: 'NCAP Child Occupant Protection % (###)' },
        { field: 116, description: 'NCAP Pedestrian Protection % (###)' },
        { field: 117, description: 'NCAP Safety Assist % (###)' },
        { field: 118, description: 'NCAP Overall Rating (Set to 0,1,2,3,4 or 5 or 9 for No Data)' }
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data - Technical Data</h1>
            <p>Provides technical data items for the various vehicle types.<br /><br />
                <b>File Naming Convention</b><br /><br />
                The &lt;FILENAME&gt; is dependant on the product being produced as follows.
            </p>
            <p>CTECH.??? CARS<br />
                LTECH.??? LIGHT COMMERCIALS<br />
                HTECH.??? HEAVY COMMERCIALS<br />
                BTECH.??? BIKES<br />
                OTECH.??? OFFROAD BIKES<br /><br />

                The 3 question marks (???) on each of the above files will be replaced with the day i.e. J12 for January 12th.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p>
                <b>Notes</b><br />
                All measurements given are in metric and will be mm or kg, unless otherwise stated.
            </p>

        </div>
    );
}

export default TechnicalData;
